module.exports = __webpack_public_path__ + "tables/media/error-page-img.ba6ab3b2.svg";